import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import { useApi } from "../lib/api";
import { StackCard } from "../components/Cards";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") ?? "";
  const [value, setValue] = useState(q);
  const { data, isLoading } = useApi("/articles", { q: q || undefined, limit: 100 });
  const items = Array.isArray(data?.items) ? data.items : [];

  return (
    <main className="pt-32 pb-24 max-w-[1440px] mx-auto px-5 sm:px-10" data-testid="search-page">
      <Seo title={q ? `“${q}” — Search | YOUTH` : "Search the archive | YOUTH"} path="/search" noindex />
      <p className="kicker text-rose">{q ? "Search results" : "The archive"}</p>
      <form onSubmit={(e) => { e.preventDefault(); setParams(value.trim() ? { q: value.trim() } : {}); }} className="flex items-center gap-4 border-b-2 border-ink mt-3 pb-3">
        <SearchIcon className="h-8 w-8 shrink-0" />
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="Search stories, tags, writers" className="w-full bg-transparent outline-none display text-4xl sm:text-7xl placeholder:text-ink/30" data-testid="search-page-input" />
      </form>
      <p className="kicker mt-5 text-ink/70" data-testid="search-count">{isLoading ? "Searching…" : `${data?.total ?? 0} stories${q ? ` for “${q}”` : ""}`}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12 mt-10">
        {items.map((a, i) => (
          <Reveal key={a.slug} delay={(i % 4) * 0.06}>
            <StackCard a={a} showDek={false} testId={`search-result-${i}`} />
          </Reveal>
        ))}
      </div>
      {!isLoading && !items.length && <p className="font-serif italic text-3xl mt-16" data-testid="search-empty">Nothing yet. Try “skate”, “nails” or “Berlin”.</p>}
    </main>
  );
}
